module.exports = __webpack_public_path__ + "img/UtilityTabClicked_ua.e92e5c06.webp";